// extracted by mini-css-extract-plugin
module.exports = {"container":"AccountPage_container__12NtJ","tabs":"AccountPage_tabs__2jTnr"};